import { render, staticRenderFns } from "./UpdateAuthMode.vue?vue&type=template&id=2320c464"
import script from "./UpdateAuthMode.vue?vue&type=script&lang=js"
export * from "./UpdateAuthMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports